import "./progresBarr.css";
const ProgressBarr = ({ sum, count, i,j}) => {


  const renderProgressBarr = () => (
    
    <div className="progresBarrVoteContainer" >
    

        <div className="col-5 percentagerVoteProgressBarre">{`${Math.floor((100 / sum) * count)}%`}</div>

        <div className="progress" style={{ height: "40%", width: "100%" }}>
      
          <div
            className="progress-bar"
            role="progressbar"
            style={{
              height:"100%",
              width: `${(100 / sum) * count}%`,
              backgroundColor: `rgba(${190 - (100 / sum) * count},235,0)`
            }}
            aria-valuenow={5}
            aria-valuemin={0}
            aria-valuemax={100}
          />
         
        </div>

    </div>
  );

  // backgroundColor: `rgb(${130 - (100 / sum) * count}, 84, ${
  //   150 + (100 / sum) * count
  // })`

  const ClosingNavBarr = () => (
    
    <div className="progresBarrVoteContainerClosing" >
    

     

        <div className="progress" style={{ height: "7px", width: "100%" }}>
          <div
            className="progress-bar"
            role="progressbar"
            style={{
              width: `${(100 / sum) * count}%`,
              backgroundColor: `rgb(${60 - (100 / sum) * count}, 0, ${
                150 + (100 / sum) * count
              })`
            }}
            aria-valuenow={5}
            aria-valuemin={0}
            aria-valuemax={100}
          />

        </div>

    </div>
  );
  return (sum>0?renderProgressBarr():ClosingNavBarr());
};
export default ProgressBarr;
